<template>
  <div id="content">{{ result }}</div>
</template>

<script>
export default {
  data() {
    return {
      result: ''
    };
  },
  created() {
    if (this.$route.query.token && this.$route.query.id) {
      let loginInfo = {
        token: this.$route.query.token,
        id: this.$route.query.id
      }
      this.$store.dispatch("user/transferLogin", loginInfo).then(() => {
        this.result = 'success';
      });
    }
  },
  methods: {}
};
</script>

<style></style>
